import { useState, useEffect } from "react";
import axios from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { DATA_KEYS } from "@/utils/useRemoteData";
import { Input } from "../../shadcn/input";
import { SpotToast } from "../../SpotToast";

export function ModalTitleInput({
  credentialId,
  groupId,
  initial,
}: {
  credentialId: string;
  groupId: string;
  initial: string | null;
}) {
  const [value, setValue] = useState(initial ?? "");
  const [saved, setSaved] = useState(initial ?? "");
  const [saving, setSaving] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    setValue(initial ?? "");
    setSaved(initial ?? "");
  }, [initial]);

  const commit = async () => {
    const trimmed = value.trim();
    if (trimmed === saved) return;
    setSaving(true);
    try {
      await axios.patch(
        `/api/backend/groups/${groupId}/integrations/credentials/${credentialId}/label`,
        { display_name: trimmed || null }
      );
      setSaved(trimmed);
      queryClient.invalidateQueries({ queryKey: [DATA_KEYS.INTEGRATIONS] });
      queryClient.invalidateQueries({
        queryKey: [DATA_KEYS.INTEGRATIONS_CONFIG],
      });
    } catch {
      SpotToast.error("Failed to save title.");
      setValue(saved);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Input
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === "Enter") commit();
        if (e.key === "Escape") {
          setValue(saved);
        }
      }}
      disabled={saving}
      placeholder={saved || "Add a title\u2026"}
      className="bg-background w-full"
    />
  );
}
